module.exports = __webpack_public_path__ + "static/media/OpenOffice2.23e477c6.jpg";